export default {
  questionIndex: {
    ar: 'السؤال',
    en: 'Question'
  },

  timeLeft: {
    ar: 'الوقت المتبقي',
    en: 'Time remaining'
  },

  confirm: {
    ar: 'تأكيد الإجابة',
    en: 'Confirm Answer'
  }
};
